//Productページのスライド
// サムネイル
const sliderThumbnail = new Swiper(".slider-thumbnail", {
  slidesPerView: 'auto',
  spaceBetween: 12,
  grabCursor: true,
  scrollbar: {
      el: '.slider-thumbnail .swiper-scrollbar',
      draggable: true,
  },
});

// メインスライダー
const swiper = new Swiper(".main_swiper", {
  slidesPerView: 1,
  centeredSlides: true,
  effect: 'fade',
  fadeEffect: {
      crossFade: true,
  },
  thumbs: {
    swiper: sliderThumbnail,
  },
});

// バリデーション
var flag = false;
$('#product_form_8426900685115 button[name="add"]').on('click',function(){
  $('#product_form_8426900685115 .error').remove();
  $('#product_form_8426900685115 select').each(function(){
    if($(this).val() != '選択してください'){
      flag = true;
    } else {
      flag = false;
      $(this).parents('.option').after('<div class="error">※必須項目です</div>');
    }
  });
  if(flag){
    $('#product_form_8426900685115').submit();
  }
});